import { AxiosInstance } from "axios"

import { MeetingServicePriceListCategory } from "../../../../../shared/components/createOrder/components/shop/priceLists/priceListsTypes"

export enum CompanyMeetingServicePriceListsQuery {
    LIST = "company-meeting-service-price-lists",
}

export type CompanyPriceListItem = Readonly<{
    id: number
    displayName: string
    colorCode?: string
    category?: MeetingServicePriceListCategory
    isFavorite: boolean
}>

export type CompanyMerchantPriceLists = Readonly<{
    id: number
    displayName: string
    address?: Readonly<{ displayName?: string }>
    shop: Readonly<{ id: number; displayName: string }>
    priceLists: ReadonlyArray<CompanyPriceListItem>
}>

export type CompanyMeetingServicePriceListsResponse = Readonly<{
    merchants: ReadonlyArray<CompanyMerchantPriceLists>
}>

export type CompanyMeetingServicePriceListsParams = Readonly<{
    companyId: number
}>

export async function fetchCompanyMeetingServicePriceLists(
    { companyId }: CompanyMeetingServicePriceListsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CompanyMeetingServicePriceListsResponse> {
    const { data } = await axios.get(`/companies/${companyId}/meetingService/priceLists`, { signal })

    return data
}
